import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { JSX } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  item: {
    img: JSX.Element;
    navigateTo: string;
    title: string;
    subtitle: string;
  };
}

export const PanelCard = ({ item }: Props) => {
  const navigate = useNavigate();

  return (
    <Card
      sx={{
        width: '100%',
        borderRadius: 0,
      }}
    >
      <CardActionArea onClick={() => navigate(item.navigateTo)}>
        {item.img}
        <CardContent sx={{ paddingTop: 1, paddingBottom: 3 }}>
          <Typography
            sx={{
              fontSize: '1.25rem',
              lineHeight: '32px',
              color: 'primary.main',
              fontWeight: 'medium',
              pb: 1,
            }}
          >
            {item?.title}
          </Typography>
          <Typography
            sx={{
              fontSize: '1rem',
              lineHeight: '24px',
              color: 'rgba(0, 0, 0, 0.6)',
            }}
          >
            {item?.subtitle}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
